// Conveniently import this file anywhere to use db
import {config, listConfig} from '@src/config';
import {firestore, FieldPath, Timestamp, GeoPoint, FieldValue,
  FcmFirestore, FcmFirebase, AggregateField} from '@src/libs/FcmFirestore/FcmFirestore';
import {initializeApp} from 'firebase/app';
import { getAnalytics, setUserProperties, logEvent } from 'firebase/analytics';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getAuth, connectAuthEmulator} from 'firebase/auth';


// import firebase from 'firebase/app';
// import 'firebase/firestore';
// import 'firebase/database';
// import 'firebase/auth';
// import 'firebase/functions';
import * as Bowser from 'bowser';

// import 'firebase/analytics';


//
// <!-- Load the Firebase SDKs before loading this file -->
// <script src="/__/firebase/init.js"></script>
//
// fetch('/__/firebase/init.json').then(async response => {
//   firebase.initializeApp(await response.json());
// });


const app = initializeApp(config.firebase);

firestore.fcmInit(app);
// firebase.firestore().settings({cacheSizeBytes: 3e+8});
// firebase.firestore().enablePersistence({synchronizeTabs: true}).catch((err)=>{
//   console.error('Firestore, Erro ao habilitar Persistência, pode ser que tenha outra aba aberta do sistema', err);
// });

let _analytics = null;

if(config.configId!=='emulator') {
  _analytics = getAnalytics(app);
  const browserInfo = Bowser.parse(window.navigator.userAgent);

  setUserProperties(_analytics, {
    revision: process.env.VUE_APP_VERSION_NUMBER || 0,
    plataform: browserInfo.platform.type,
    os: browserInfo.os.name,
    osVersion: browserInfo.os.version,
    osVersionName: browserInfo.os.versionName,
    browser: browserInfo.browser.name,
    browserVersion: browserInfo.browser.version,
  });
}

const analytics = { // Wraper da analytics no formato da analytics antiga
  logEvent: (...args)=>{
    if(config.configId!=='emulator') {
      return logEvent(_analytics, ...args);
    }
  }
};


const realtimeDatabaseAdditionals = [];

const functions = getFunctions(app, config.region);
functions.httpsCallable = (...args) => {
  return httpsCallable(functions, ...args);
};
const database = getDatabase(app);

function startRealtimeDatabaseAdditionals() {
  if (!realtimeDatabaseAdditionals.length) {
    for (const url of config.realtimeDatabaseAdditionals || []) {
      realtimeDatabaseAdditionals.push(getDatabase(app, url));
    }
  }
}

const auth = getAuth(app);
const storage = getStorage(app);

// Debug functions local http and onCall
if(config.configId==='emulator') {
  firestore.useEmulator('localhost', 47673);
  connectFunctionsEmulator(functions, 'localhost', 47672);
  connectStorageEmulator(storage, 'localhost', 47678);
  connectAuthEmulator(auth, 'http://localhost:47676');
  connectDatabaseEmulator(database, 'localhost', 47677);
}
FcmFirebase.functions = () =>{
  return functions;
};
FcmFirebase.auth = () =>{
  return auth;
};

FcmFirebase.auth = () => {
  return auth;
};
window.firebaseInjectCommon = FcmFirebase;

if(process.env.NODE_ENV !== 'production') {
  if (process.env.DEBUG_FIRESTORE) {
    firestore.debug = true;
  }
  window.jwDebug ||= {};
  window.firebaseDebug = FcmFirebase;
  if(process.env.USE_LOCAL_CLOUD) {
    connectFunctionsEmulator(functions, 'localhost', 47672);
    // firestore.useEmulator('localhost', 47673);
  }
  // connectFunctionsEmulator(functions, 'localhost', 47672);

  window.jwDebug.functions = functions;

  window.firebaseInternal = new FcmFirestore(initializeApp(listConfig.volaninternal.firebase, 'VolanInternal'));
  window.firebaseDev = new FcmFirestore(initializeApp(listConfig.volandevjw.firebase, 'VolanDev'));
  window.firebaseProd = new FcmFirestore(initializeApp(listConfig.volanjwcg.firebase, 'VolanProd'));
}

// firebase.firestore().enablePersistence({synchronizeTabs: true});





export {FieldPath, Timestamp, GeoPoint, FieldValue, firestore,
  functions, database, auth, analytics, storage, AggregateField, realtimeDatabaseAdditionals, startRealtimeDatabaseAdditionals};
